export default __webpack_public_path__ + "static/media/zoomedNet.c104c57f.PNG";